import type { ResponseError } from 'shared/types/response-errors';

function parseResponseError(error: ResponseError) {
  if (error.message.includes('Internal server Error') && error.extensions.debugMessage) {
    return error.extensions.debugMessage;
  }
  return error.message;
}

export default parseResponseError;
